import { render, staticRenderFns } from "./childManagement.vue?vue&type=template&id=10256cca"
import script from "./childManagement.vue?vue&type=script&lang=js"
export * from "./childManagement.vue?vue&type=script&lang=js"
import style0 from "./childManagement.vue?vue&type=style&index=0&id=10256cca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports